export default __webpack_public_path__ + "static/media/mobile-apps.e48f6fd0.png";